import React, {useEffect, useState} from 'react'
import PanelHead from '../../Panel/PanelHead'
import PanelBody from '../../Panel/PanelBody'
import {FormEditShop} from './FormEditShop'
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {useParams} from "react-router-dom";
import {FormEditMembershipService} from "../../MembershipService/Edit/FormEditMembershipService";
import {CircularProgress, LinearProgress} from "@mui/material";

export const PanelEditShop = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [ourServiceData, setOurServiceData] = useState(null);

    const [groups, setGroups] = useState([]);
    const [isGroupsLoading, setIsGroupsLoading] = useState(true);

    const fetchData = async () => {
        try {
            // Fetch membership details
            const {response: ourServiceResponse} = await Helper.Get({
                url: api_Routes.ShopAds.GetOne + `/${id}`,
            });
            const {response: groupsResponse} = await Helper.Get({
                url: api_Routes.MembershipGroup.ViewAll,
            });

            if (ourServiceResponse && groupsResponse) {
                setOurServiceData({
                    ...ourServiceResponse.data,
                    is_active: Boolean(ourServiceResponse.data.is_active),
                    all: Boolean(ourServiceResponse.data.all),
                    groups: ourServiceResponse.data.groups?.map(s => s.id) || []
                });
                setGroups(groupsResponse.data)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
            setIsGroupsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Advertising <CircularProgress size={24}/>
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Advertising: {ourServiceData?.name}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress/>
                    ) : (
                        <FormEditShop
                            ourServiceData={ourServiceData}
                            setOurServiceData={setOurServiceData}
                            groups={groups}
                            isGroupsLoading={isGroupsLoading}/>
                    )
                }
            />
        </div>


    )
}
